import { Context } from '@nuxt/types';
import SessionModule from '~/store/session';

export default async function (context: Context) {
	const session = context.container.get(SessionModule);
	const redirect = context.redirect;
	// await session.ensure();
	if (session.isHub) {
		return redirect('/');
	}
	return true;
}
